import React, { useState, useEffect } from "react";

export default function LeaveRoomConfirmModal({ onClose, onConfirm }) {
  const [isAnimating, setIsAnimating] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setIsAnimating(true), 10);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsAnimating(false);
    setTimeout(onClose, 300);
  };

  const handleConfirm = () => {
    setIsAnimating(false);
    setTimeout(onConfirm, 300);
  };

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center z-50 p-4 transition-colors duration-300 ${
        isAnimating ? "bg-black/70" : "bg-black/0"
      }`}
      onClick={handleClose}
    >
      <div
        className={`bg-[#f3e9d2] text-[#5a4a3a] p-6 rounded-lg shadow-2xl border-4 border-gray-700 w-full max-w-sm flex flex-col items-center gap-4 transition-all duration-300 ease-out ${
          isAnimating ? "scale-100 opacity-100" : "scale-75 opacity-0"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <p className="text-xl font-bold font-serif text-center">
          ยืนยันการออกจากห้อง
        </p>
        <p className="text-center">คุณแน่ใจหรือไม่ว่าจะออกจากห้องนี้?</p>
        <div className="flex gap-4 w-full mt-2">
          <button
            onClick={handleClose}
            className="w-full bg-[#a08d70] hover:bg-[#8d7c62] text-white font-bold py-3 px-4 rounded-lg transition-transform active:scale-95"
          >
            ยกเลิก
          </button>
          <button
            onClick={handleConfirm}
            className="w-full bg-[#b22222] hover:bg-[#8B0000] text-white font-bold py-3 px-4 rounded-lg transition-transform active:scale-95"
          >
            ยืนยัน
          </button>
        </div>
      </div>
    </div>
  );
}
